import { render } from "./EventHistoryDetails.vue?vue&type=template&id=139185a2"
import script from "./EventHistoryDetails.vue?vue&type=script&lang=js"
export * from "./EventHistoryDetails.vue?vue&type=script&lang=js"
script.render = render

export default script